import React from 'react';
import { Chat } from '../components/Chat';

export const ChatPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto h-screen">
        <Chat className="h-full" />
      </div>
    </div>
  );
};
